import React, { useContext } from 'react';

import { CrossIcon } from '@mc/wink-icons';
import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';
import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import IconButton from '../IconButton';
import type { IconButtonSize } from '../IconButton/IconButton';
import { ModalCloseContext, type ModalSize } from './Modal';

import stylesheet from './Modal.css';
import { ModalContext } from './ModalContext';

type ModalCloseButtonProps = {
  size?: IconButtonSize;
};

const ModalCloseButton = ({ size }: ModalCloseButtonProps) => {
  const modalSize = useContext(ModalContext)?.size;
  let computedSize: ModalSize = 'medium';

  if (mcdsFlagCheck('xp_mcds_modal_width_fix')) {
    if (size) {
      computedSize = size;
    } else if (modalSize === 'small') {
      computedSize = 'small';
    }
  } else {
    // If size is provided, use it, otherwise use the modal size (fallback to medium if large when flag is enabled), otherwise use medium
    computedSize = size || modalSize === 'large' ? 'medium' : modalSize;
  }

  const onRequestClose = useContext(ModalCloseContext);
  // Translate default text
  const closeModalText = useDsTranslateMessage({
    id: 'mcds.modal.close_modal_text',
    defaultMessage: 'Close Modal',
  });

  return (
    <IconButton
      className={stylesheet.closeButton}
      icon={<CrossIcon />}
      label={closeModalText}
      // @ts-expect-error TS(2322) FIXME: Type 'unknown' is not assignable to type '(MouseEv... Remove this comment to see the full error message
      onClick={onRequestClose}
      type="secondary"
      size={computedSize as IconButtonSize}
    />
  );
};

export default ModalCloseButton;
